export default __webpack_public_path__ + "static/media/poesi.55eb53dd.jpeg";